import React, { useEffect, useRef, useState } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { getApiBaseUrl } from '../../config/apiBase';

export default function TreasurerNotice({ groupId }) {
  const { getAccessTokenSilently } = useAuth0();
  const tokenRef = useRef(getAccessTokenSilently);
  tokenRef.current = getAccessTokenSilently;
  const [status, setStatus] = useState(null);
  useEffect(() => {
    let active = true;
    setStatus(null);
    if (groupId) tokenRef.current().then(token => fetch(`${getApiBaseUrl()}/api/groups/${groupId}/treasurer`,
      { headers: { Authorization: `Bearer ${token}` } })).then(r => r.ok ? r.json() : null)
      .then(data => { if (active) setStatus(data); }).catch(() => {});
    return () => { active = false; };
  }, [groupId]);
  if (!status || !Array.isArray(status.names)) return null;
  return <aside className="treasurer-notice" style={{ padding: '1rem', border: '1px solid #b3a163', borderRadius: 12, margin: '1rem 0' }}>
    <strong>{status.interim ? 'Treasurer not yet elected' : status.vacant ? 'Treasurer position is vacant' : 'Elected treasurer'}</strong>
    <p>{status.interim ? `${status.names.join(', ') || 'The founder'} is acting as interim treasurer until an elected treasurer accepts.` :
      status.vacant ? 'Elect a replacement. Financial access does not automatically return to the founder.' : status.names.join(', ')}</p>
    <small>The group’s receiving account stays with the organization. A change of treasurer changes TYK permissions; Stripe team access must be handed over separately. Financial permissions do not override group votes.</small>
  </aside>;
}
